<header tuiNavigationHeader>
  <div class="flex w-full items-center">
    <button
      size="s"
      tuiButton
      [routerLink]="MAIN_PAGE">
      <b class="flex">
        <span>TRUST</span>
        CHECKER
      </b>
    </button>

    <div class="absolute left-1/2 -translate-x-1/2 flex items-center gap-x-2">
      @for (item of availableMenuItems(); track $index) {
        <button
          size="s"
          tuiButton
          type="button"
          (click)="navigate(item)">
          <b>{{ item.name }}</b>
        </button>
      }
    </div>

    @if (isAuthenticated()) {
      <app-user-menu class="mr-0 ml-auto"></app-user-menu>
    } @else {
      <button
        iconStart="@tui.log-in"
        size="s"
        tuiIconButton
        type="button"
        class="mr-0 ml-auto"
        [routerLink]="LOGIN_PAGE"></button>
    }
  </div>
</header>
